// hooks/useArticles.ts
import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import {
  getAdminAccessToken,
  getStoreAccessToken,
  getStoreId,
} from "../../utils/auth";
import { Review } from "../../types/modules/review.type";

interface UseReviewParams {
  rating?: number;
  page?: number;
  limit?: number;
  storeId?: number;
}

export const useStoreReviews = ({
  rating,
  page = 1,
  limit = 10,
  storeId,
}: UseReviewParams) => {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  if (rating) {
    queryParams.append("rating", rating.toString());
  }

  if (storeId) {
    queryParams.append("storeId", storeId.toString());
  }

  const storeIdToSend = storeId ? storeId : getStoreId();
  const token = storeId ? getAdminAccessToken() : getStoreAccessToken();

  return useQuery({
    queryKey: ["store-reviews", page, limit, rating, storeIdToSend, token],
    queryFn: () =>
      fetcher<{ data: Review[]; totalPages: number; totalItems: number }>(
        `review/all?${queryParams.toString()}`,
        token
      ),
  });
};
